var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "20px",
    viewBox: "0 0 28 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "flags / GI") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 28,
    height: 20,
    rx: 2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flags-/-GI",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("rect", {
    stroke: "#F5F5F5",
    strokeWidth: 0.5,
    x: 0.25,
    y: 0.25,
    width: 27.5,
    height: 19.5,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    fill: "#E34F4F",
    mask: "url(#mask-2)",
    x: 0,
    y: 13.3333333,
    width: 28,
    height: 6.66666667
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    fill: "#E34F4F",
    mask: "url(#mask-2)",
    x: 9.33333333,
    y: 8,
    width: 8,
    height: 5.33333333
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    fill: "#181A1A",
    mask: "url(#mask-2)",
    x: 10.6666667,
    y: 12,
    width: 1.33333333,
    height: 1.33333333
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    fill: "#181A1A",
    mask: "url(#mask-2)",
    x: 14.6666667,
    y: 12,
    width: 1.33333333,
    height: 1.33333333
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    fill: "#181A1A",
    mask: "url(#mask-2)",
    x: 9.33333333,
    y: 6.66666667,
    width: 1.33333333,
    height: 1.33333333
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    fill: "#181A1A",
    mask: "url(#mask-2)",
    x: 13.3333333,
    y: 6.66666667,
    width: 1.33333333,
    height: 1.33333333
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    fill: "#181A1A",
    mask: "url(#mask-2)",
    x: 12,
    y: 6.66666667,
    width: 1.33333333,
    height: 1.33333333
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    fill: "#181A1A",
    mask: "url(#mask-2)",
    x: 16,
    y: 6.66666667,
    width: 1.33333333,
    height: 1.33333333
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    fill: "#E34F4F",
    mask: "url(#mask-2)",
    x: 9.33333333,
    y: 5.33333333,
    width: 1.33333333,
    height: 1.33333333
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    fill: "#E34F4F",
    mask: "url(#mask-2)",
    x: 13.3333333,
    y: 5.33333333,
    width: 1.33333333,
    height: 1.33333333
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    fill: "#E34F4F",
    mask: "url(#mask-2)",
    x: 12,
    y: 5.33333333,
    width: 1.33333333,
    height: 1.33333333
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    fill: "#E34F4F",
    mask: "url(#mask-2)",
    x: 16,
    y: 5.33333333,
    width: 1.33333333,
    height: 1.33333333
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGi);
export default __webpack_public_path__ + "static/media/GI.1d21e34d7aee4b7b0c6ff7d1c958ed8d.svg";
export { ForwardRef as ReactComponent };